<template>
  <div>
    <!-- <v-row class="mb-16">
      <v-col cols="12" md="12"> -->
    <!-- <v-card-title class="text-h4 font-weight-bold mb-4">
        {{ $t('sales.title') }}
    </v-card-title> -->
    <!-- 
      </v-col>
      <v-col cols="12">
        <template> -->
    <v-card color="" elevation="0" class="">
      <v-divider></v-divider>
      <template>
        <v-tabs
          color="primary"
          v-model="tabs"
          class=""
          height="80"
          background-color="#f4f4f4"
        >
          <div class="d-flex align-center px-4">
            <v-icon color="primary " size="">mdi-cart-check</v-icon>
            <h5 class="font-weight-bold headline ml-2">
              {{ $t("sales.title") }}
            </h5>
          </div>
          <v-tab class="ml-4">{{ $t("sales.ordersList.stepTitle") }}</v-tab>
          <v-tab>OPEC</v-tab>

          <v-tab>{{ $t("sales.clientsList.stepTitle") }} {{ $root.auth.profile.displayName }}</v-tab>
          <v-tab v-if="!$root.auth.profile.whitelabelId">{{ $t("sales.reserved.title") }}</v-tab>
          <v-tab v-if="!$root.auth.profile.whitelabelId">{{ $t("sales.commercialPolicies.stepTitle") }}</v-tab>
          <div class="d-flex align-center" v-if="!$root.auth.profile.whitelabelId">
            <v-tab disabled>BI</v-tab>
            <v-chip x-small class="mb-2 mt-2 px-1 ml-n6" color="info"
              ><span class="black---text">{{
                $t("sales.clientsList.underDev")
              }}</span></v-chip
            >
          </div>
      
        </v-tabs>
      </template>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <OrdersList @update-logs="updateLog = $event" :loadingLog="loadingLog" :log="orderLog" :accounts="documents"></OrdersList>
        </v-tab-item>
        <v-tab-item>
          <OpecList></OpecList>
        </v-tab-item>
        <v-tab-item>
          <AccountsList></AccountsList>
        </v-tab-item>
        <v-tab-item v-if="!$root.auth.profile.whitelabelId">
          <ReservedList></ReservedList>
        </v-tab-item>
        <v-tab-item v-if="!$root.auth.profile.whitelabelId"> 
          <CommercialPolicies/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!-- </template>
      </v-col>

    </v-row>-->
  </div>
</template>

<script>
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import config from "@/store/config";
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { initializeApp } from "firebase/app";
import OpecList from '@/components/opec/OpecList'

import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import AccountsList from "@/components/sales/AccountsList.vue";
import OrdersList from "@/components/sales/OrdersList.vue";
import ReservedList from "@/components/sales/ReservedList.vue";
import CommercialPolicies from "@/components/sales/CommercialPolicies.vue";
import moment from 'moment'
export default {
  name: "SalesTable",
  components: { AccountsList, OrdersList, ReservedList,CommercialPolicies, OpecList },
  data() {
    return {
      updateLog: 0,
      loadingLog: false,
      tabs: 0,
      orderLog: [],
      documents:null,
      loading:false,
    };
  },
  mounted() {
    this.loadTabs();
    this.loadAccounts()
    this.getLog();
    console.log('params',this.$route.params)
  },
  watch: {
    "$route.params.tab"() {
      this.loadTabs();
    },
    updateLog(){
      this.loadingLog = true
      this.getLog()
    },
    tabs(nV) {
      let query = [];
      for (let key in this.$route.query) {
        // if(nV != 0 && key == 'q')
        query.push(`${key}=${this.$route.query[key]}`);
      }
      const qstring = query.length ? `?${query.join("&")}` : "";

    
     if (nV == 0 && !this.$route.params.id && this.$route.path != "/sales/orders"){
        this.$router.replace(`/sales/orders${qstring}`);
      }
      if (nV == 1 && this.$route.path != "/sales/opec"){
        this.$router.replace(`/sales/opec${qstring}`);
      }
      if (nV == 2 && this.$route.path != "/sales/customers"){
        this.$router.replace(`/sales/customers${qstring}`);
      }
      if (nV == 3 && this.$route.path != "/sales/reserved"){
        this.$router.replace(`/sales/reserved${qstring}`);
      }
       
        if (nV == 4 && this.$route.path != "/sales/commercial-policies"){
          this.$router.replace(`/sales/commercial-policies${qstring}`);
        }
    },

     
       
      
      
      
      
  },
  methods: {
    getLog(){
      const documents = []
      const url = `whitelabel/getLog?projectId=${config.projectId}`;
      this.$axios.get(url).then((res) => {
        
        res.data.data.forEach((item) => {
          let doc = {
            "id": '',
            "name": '',
            'packages': '',
            "client": '',
            "computed": {
              "userName": '',
              "createdOn": "",
              "updatedOn": ""
            },
            "createdOn": '',
            "updatedOn": '',
            "status": '',
            "total": {
              "total": '',
              "discount": 0,
              "policyDiscount": 0,
              "couponDiscount": 0,
              "final": 0,
            }
          }
          const nitem = {...doc, ...item}
          nitem.cartId = item.id
          nitem.id = item._id['$id']
          nitem.createdOn = item.date
          nitem.name = item.orderName
          // nitem.user = item.user && item.user.name ? item.user.name : ''
          nitem.updatedOnX = item.updatedOn ? moment(item.updatedOn).format('X') : moment(item.date).format('X')
          nitem.computed.createdOn = item.createdOn ? moment(item.createdOn).format() : moment(item.date).format()
          nitem.computed.updatedOn = item.updatedOn ? moment(item.updatedOn).format() : moment(item.date).format()
          nitem.total = {
            total: item.itemDetails.price,
            final: item.itemDetails.price,

          }
          documents.push(nitem)
        })
        this.orderLog = documents
        this.loadingLog = false
      })
    },  
    loadAccounts(){
      this.loading = true;
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "accounts"));
      const querySnapshot = getDocs(q);
      const documents = [];
      querySnapshot.then((docs) => {
        docs.forEach((doc) => {
          //console.log('data',doc.data())
          documents.push({ ...doc.data()});
        });
        this.documents = documents;
        this.loading = false;
      });
    },
   

    loadTabs() {
      if (!this.$route.params.tab) {
        this.tabs = 0;
      } else {
       
        if (this.$route.params.tab == "orders") {
          this.tabs = 0;
          
        }
         if (this.$route.params.tab == "opec") {
          this.tabs = 1;
        }
         if (this.$route.params.tab == "customers") {
          this.tabs = 2;

        }
        if (this.$route.params.tab == "reserved") {
          this.tabs = 3;
        }

       
        if (this.$route.params.tab == "commercial-policies") {
          this.tabs = 4;
        }
      }
    }}}
</script>

<style lang="scss" scoped></style>
